import { render, staticRenderFns } from "./Styleguide.vue?vue&type=template&id=78cb3ee8&"
import script from "./Styleguide.vue?vue&type=script&lang=js&"
export * from "./Styleguide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports